import TextInput, {TextInputWithoutContainer} from "../TextInput/TextInput";
import Select from "../Select/Select";
import {PickDate} from "../PickDate/PickDate";
import {Fragment, useState} from "react";
import ImageInput from "../ImageInput/ImageInput";
import uploadPlaceholder from "../../assets/upload-file.svg";
import {baseImagesUrl} from "../../assets/Constants";
import StaticLoginForm from "../StaticLoginForm/StaticLoginForm";
import AddressForm from "../AddressForm/AddressForm";

const PersonForm = ({person, onChange}) => {
    const address = {
        townId: "1",
        address: "",
        picture: "",
        location : {
            lat : "",
            lng : ""
        }
    };

    const [tempValues, setTempValues] = useState({
        phonenumber: "",
    })
    const changeTempValues = (key, value) => {
        const newTempValues = {...tempValues, [key]: value};
        setTempValues(newTempValues);
    }
    const changePerson = (key, value) => {
        const newPerson = {...person, [key]: value};
        onChange(newPerson);
    }

    const sexOptions = [
        {
            label: "مرد",
            value: "MALE",
        }, {
            label: "زن",
            value: "FEMALE",
        }
    ];

    return (
        <div className={"row"}>
            <div className="col-md-6">
                <TextInput label={"نام"} value={person.firstname} onChange={(value) => {
                    changePerson("firstname", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"نام خانوادگی"} value={person.lastname} onChange={(value) => {
                    changePerson("lastname", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput label={"نام مستعار در اپلیکیشن"} value={person.nickname} onChange={(value) => {
                    changePerson("nickname", value)
                }}/>
            </div>
            <div className="col-md-6">
                <Select label={"جنسیت"} options={sexOptions} value={person.sex} onChange={(value) => {
                    changePerson("sex", value)
                }}/>
            </div>

            <div className="col-md-6">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2">شماره های تماس</label>
                        {
                            person.phonenumbers.length == 0 &&
                            <div className={"alert alert-warning"}>شماره ای ثبت نشده!</div>
                        }
                        <ul className={"list-group mb-5"}>
                            {
                                person.phonenumbers.map((phonenumber, index) => {
                                    return (<li key={index}
                                                className={`list-group-item ${phonenumber == person.activePhonenumber ? "active" : ""}`}
                                                onDoubleClick={() => {
                                                    changePerson('activePhonenumber', phonenumber)
                                                }}
                                    >{phonenumber}</li>)
                                })
                            }
                        </ul>

                        <TextInputWithoutContainer
                            type={"number"}
                            label={"افزودن شماره تماس"}
                            value={tempValues.phonenumber}
                            onChange={(value) => {
                                changeTempValues("phonenumber", value);
                            }}
                        />
                        <button className={"btn btn-success mb-4 w-100"}
                                onClick={() => {
                                    const newPhonenumbers = [...person.phonenumbers, tempValues.phonenumber];
                                    changePerson("phonenumbers", newPhonenumbers);
                                    changeTempValues("phonenumber", "")
                                }}
                        >افزودن
                        </button>
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <PickDate label={"تاریخ تولد"} timestamp={person.birthday} onChange={(value) => {
                    changePerson("birthday", value)
                }}/>
            </div>

            <div className="col-md-2">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2">پروفایل</label>
                        <ImageInput
                            defaultPic={person.profile ? (person.profile.includes("person") ? `${baseImagesUrl}person/${person.profile}` : person.profile) : uploadPlaceholder}
                            onChange={(value) => {
                                changePerson("profile", value)
                            }}/>
                    </div>
                </div>

            </div>

            <div className="col-12">
                <StaticLoginForm staticLogin={person.staticLogin} onChange={(value) => {
                    const newStaticLogin = {...person.staticLogin, ...value};
                    changePerson("staticLogin", newStaticLogin);
                }}/>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <label className="card-title mb-2">آدرس ها</label>
                        {person.addresses.map((address, index) => {
                            return (<Fragment key={index}>
                                    <AddressForm address={address} onChange={(value) => {
                                        const newAddresses = [...person.addresses]
                                        newAddresses[index] = {...newAddresses[index], ...value};
                                        changePerson("addresses", newAddresses);
                                    }}/>
                                    <button className={"btn btn-danger w-100"} onClick={() => {
                                        const newAddresses = person.addresses.filter((a, i) => {
                                            if (index != i)
                                                return a;

                                        });
                                        changePerson("addresses", newAddresses);
                                    }}>حذف آدرس بالا
                                    </button>
                                </Fragment>
                            )
                        })
                        }
                        <button className={'btn btn-success w-100 mt-4'} onClick={() => {
                            const newAddresses = [...person.addresses, {...address}];
                            changePerson("addresses", newAddresses);
                        }}>افزودن آدرس
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PersonForm;